import {
  GET_KIND,
  GET_KIND_FAIL,
  GET_KIND_SUCCESS,
  GET_KINDS,
  GET_KINDS_FAIL,
  GET_KINDS_SUCCESS,
  ADD_NEW_KIND,
  ADD_KIND_SUCCESS,
  ADD_KIND_FAIL,
  UPDATE_KIND,
  UPDATE_KIND_SUCCESS,
  UPDATE_KIND_FAIL,
  DELETE_KIND,
  DELETE_KIND_SUCCESS,
  DELETE_KIND_FAIL,
  SET_STATE_KIND,
  UPDATE_KIND_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_KIND,
  payload: loading,
})

export const getKinds = ( params ) => ({
  type: GET_KINDS,
  payload: { params },
})

export const getKindsSuccess = (kinds, totalPages, currentPage) => ({
  type: GET_KINDS_SUCCESS,
  payload: { kinds:kinds, total:totalPages, currentPage:currentPage}
})

export const getKindsFail = error => ({
  type: GET_KINDS_FAIL,
  payload: error,
})

export const addNewKind = kind => ({
  type: ADD_NEW_KIND,
  payload: kind,
})

export const addKindSuccess = kind => ({
  type: ADD_KIND_SUCCESS,
  payload: kind,
})  

export const addKindFail = error => ({
  type: ADD_KIND_FAIL,
  payload: error,
})

export const updateKind = kind => ({
  type: UPDATE_KIND,
  payload: kind,
})

export const updateKindStatus = kind => ({
  type: UPDATE_KIND_STATUS,
  payload: kind,
})

export const updateKindSuccess = kind => ({
  type: UPDATE_KIND_SUCCESS,
  payload: kind,
})

export const updateKindFail = error => ({
  type: UPDATE_KIND_FAIL,
  payload: error,
})

export const deleteKind = kind => ({
  type: DELETE_KIND,
  payload: kind,
})

export const deleteKindSuccess = id => ({
  type: DELETE_KIND_SUCCESS,
  id,
})

export const deleteKindFail = error => ({
  type: DELETE_KIND_FAIL,
  payload: error,
})

export const getKind = () => ({
  type: GET_KIND,
})

export const getKindSuccess = kind => ({
  type: GET_KIND_SUCCESS,
  payload: kind,
})

export const getKindFail = error => ({
  type: GET_KIND_FAIL,
  payload: error,
})
